import type { KakaoShareClient, KakaoSdk } from "./kakao.types";

type KakaoSdkWithLink = KakaoSdk & {
  Link?: KakaoShareClient;
};

/** Share API (SDK 2.x) with legacy Link fallback. */
export const resolveKakaoShareClient = (Kakao: KakaoSdk): KakaoShareClient => {
  const sdk = Kakao as KakaoSdkWithLink;
  const share = sdk.Share ?? sdk.Link;

  if (!share?.sendDefault) {
    throw new Error(
      "Kakao Talk Share API is unavailable. Enable Kakao Talk Message for your app in Kakao Developers.",
    );
  }

  return share;
};
